import React from 'react';
import { FaEye } from 'react-icons/fa';


interface PageHeaderProps {
  onPreview: () => void;
  onPublish: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({ onPreview, onPublish }) => {
  return (
    <header className="bg-white px-6 py-4 border-b border-gray-200">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Create Learning Path</h1>
          <p className="text-gray-600 mt-1">Build a structured learning experience by selecting and sequencing courses and assessments</p>
        </div>
        <div className="flex items-center space-x-3">
          {/* <button 
            onClick={onPreview}
            className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center"
          >
            <FaEye size={16} className="mr-2" />
            Preview
          </button> */}
          <button 
            onClick={onPublish}
            className="px-4 py-2 bg-darkBlue text-white rounded-lg flex items-center"
          >
            
            Publish Path
          </button>
        </div>
      </div>
    </header>
  );
};

export default PageHeader;